import { ResponseReult } from 'sync-engine';
import { FormProperty } from 'ms-form-builder';
import { AppNestjsResponse } from 'nestjs-model-utility';
import { Observable } from 'rxjs';
import { messageResponseType } from 'buttons-modal';
import { simpleDeleteFormAction } from 'widget-utility';
import { nestjsActionResponseMapper } from 'nestjs-model-utility';

export function baseDeleteFormAction<Value, Data>(
  responseReturner: () => Observable<ResponseReult<AppNestjsResponse<Data>>>,
  messageType: messageResponseType = 'toast',
  callBack?: (formProperty?: FormProperty<Value, any>) => void,
  modalHeader?: string,
  modalMessage?: string,
) {
  return simpleDeleteFormAction(
    () => responseReturner(),
    nestjsActionResponseMapper,
    modalMessage,
    messageType,
    modalHeader,
    callBack,
  );
}
